var map = {
	"./best-sale.svg": "e64a",
	"./building.svg": "fd0a",
	"./check.svg": "3339",
	"./co-broking.svg": "b286",
	"./commission.svg": "3cd5",
	"./email.svg": "a677",
	"./hamburger.svg": "2d5d",
	"./marketing.svg": "a64b",
	"./operation-team.svg": "b655",
	"./password.svg": "436c",
	"./sales-management.svg": "a20b",
	"./stock.svg": "a7dc",
	"./technology-team.svg": "4a14",
	"./telphone.svg": "4573",
	"./user.svg": "16e4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1697";